import { useCallback } from 'react';
import { entityKey, useNotificationsByEntity } from '../../notifications/index.js';

/**
 * @aiPurpose lookup helper for per-row notification badges on
 *   `/requests` (#1072). Wraps the shared notifications-by-entity hook
 *   so the page only sees a stable `(requestId) -> number` callback,
 *   keeping the per-row component dependency-free of the underlying
 *   notification slice.
 * @aiInvariant one notifications query backs the bell + every row dot
 *   via the shared `NOTIFICATIONS_LIST_QK`; looking up by
 *   (entityType, entityId) avoids a per-row hook subscription.
 */
export function useRequestNotificationLookup(): (id: string) => number {
  const { byEntity } = useNotificationsByEntity();
  return useCallback(
    (id: string): number =>
      byEntity.get(entityKey('CHINA_REQUEST', id))?.totalUnreadAggregates ?? 0,
    [byEntity],
  );
}
